import { render, staticRenderFns } from "./BalanceCard.vue?vue&type=template&id=d019d23e&"
import script from "./BalanceCard.vue?vue&type=script&lang=ts&"
export * from "./BalanceCard.vue?vue&type=script&lang=ts&"
import style0 from "./BalanceCard.vue?vue&type=style&index=0&id=d019d23e&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports